import { useLocation, useNavigate } from "react-router-dom";
import { ErrorBoundary } from "./errorBoundary";
import { useDispatch, useSelector } from "react-redux";
import { useNetworkMonitor } from "../../hooks/useNetworkMonitor";

const ErrorBoundaryWrapper = (props) => {
  const navigate = useNavigate();
  const errorData = useSelector((state) => state.errorReducer);
  const location = useLocation();
  const dispatch = useDispatch();
  // Activate the global network monitor
  useNetworkMonitor();

  return (
    <>
      <ErrorBoundary navigate={navigate} routeKey={location.pathname} errorData={errorData} dispatch={dispatch} {...props} />
    </>
  );
};

export default ErrorBoundaryWrapper;
